export default `
  mutation deleteCardComment($id: ID!, $workflowId: String!, $cardId: String!) {
    deleteCardComment(id: $id, workflowId: $workflowId, cardId: $cardId) {
      workflowId
      cardId
      id
    }
  }
`
